// Mirrors MAX_ADMIN_WASHES in backend/referral.py (admin_update_washes and the referral top-up).
export const MAX_ADMIN_WASHES = 100;

// Same rule as the backend: the ceiling limits increases only, so it is never below a gift's
// grant or the value the row already holds.
export const washesCeiling = (granted, current) =>
  Math.max(MAX_ADMIN_WASHES, granted || 0, current || 0);

export const parseWashesInput = (text, ceiling) => {
  const trimmed = String(text ?? '').trim();
  if (!/^\d+$/.test(trimmed)) {
    return { ok: false, error: 'Introdu un număr întreg de spălări' };
  }
  const value = Number(trimmed);
  if (value > ceiling) {
    return { ok: false, error: `Numărul de spălări trebuie să fie între 0 și ${ceiling}` };
  }
  return { ok: true, value };
};

// FastAPI returns a 422's `detail` as an array of objects; handing that to a toast renders an
// object as a React child. Only a string detail is shown.
export const errorDetail = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' ? detail : fallback;
};
